import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          text: "play sound",
          theme: "primary",
          icon: "cis-volume-high",
          shape: "round",

          url: `${config.ASSETS_URL}/01/22/principle/db-spl-85.wav`,
        },
      },
      styles: {
        marginLeft: "8.33%",
      },
    },
  },
];

export default component;
